// Verify the exact authenticated portal response before offering it as an original.
export async function verifyOriginal(blob, expectedSha256, digest = bytes => crypto.subtle.digest('SHA-256', bytes)) {
  if (!/^[a-f0-9]{64}$/.test(expectedSha256 || '') || !blob?.size) throw new Error('Original receipt or file is missing.')
  const bytes = await blob.arrayBuffer()
  const hash = [...new Uint8Array(await digest(bytes))].map(value => value.toString(16).padStart(2, '0')).join('')
  if (hash !== expectedSha256) throw new Error('Original bytes do not match the saved receipt. Download withheld; investigate the saved original.')
  return {sha256: hash, bytes: bytes.byteLength}
}
